<div class="row" *ngIf="!showLoader">
  <div class="col-md-12 d-flex justify-content-between align-items-end">
    <h3 class="content-title">Private RFQs</h3>
    <button class="create-quote" (click)="redirectToAssistPage()">Create Private RFQ</button>
  </div>
</div>

<div class="row" *ngIf="!showLoader">
  <div class="col-md-12">
    <p class="direct-rfq-description">
      <strong>Manage RFQs and create quotes for buyers outside the MFG Marketplace—all in one place.</strong>
      With Quote Assist, these opportunities stay 100% private to you. Streamline your quoting and manage every
      opportunity from your shop in one simple tool.
    </p>
  </div>
</div>
<div class="main-container">
  <div class="row" *ngIf="!showLoader">
    <div class="col-md-12">
      <div class="filters-container d-flex align-items-center mb-4">
        <div class="sort-container">
          <label for="sortSelect">Sort by</label>
          <select id="sortSelect" [(ngModel)]="sortOption" (change)="onSortChange()">
            <option *ngFor="let option of getFilteredSortOptions()" [value]="option.value">
              {{option.label}}
            </option>
          </select>
        </div>
        <div class="sort-container">
          <label for="rfqType">RFQ Type</label>
          <select id="rfqType" [(ngModel)]="selectedRfqType" (change)="onRfqTypeChange()">
            <option *ngFor="let type of rfqTypes" [value]="type.value">{{ type.label }}</option>
          </select>
        </div>
        <div class="filter-search">
          <i class="search-icon"><img src="/assets/img/svg/search-icon.svg"></i>
          <input type="search" [(ngModel)]="searchQuery" (input)="onSearchChange()" placeholder="Search"
            class="form-control" style="padding-left: 35px;">
        </div>
        <a class="clear-filters" (click)="clearFilters()">Clear</a>
      </div>
    </div>
  </div>
  <div *ngIf="!showLoader">
    <div class="rfq-card" *ngFor="let rfq of rfqList | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage }">
      <div class="d-flex align-items-center justify-content-between w-100 gap-3 rfq-card-container">
        <div class="col">
          <div class="d-flex align-items-center">
            <span *ngIf="rfq.isNew" class="rfq-status new">NEW</span>
            <span *ngIf="rfq.source === 'SUW'" class="rfq-status web-quote">WEBSITE QUOTE</span>
            <span *ngIf="rfq.source === 'MFGDirect'" class="rfq-status self-created">SELF Created</span>
            <span *ngIf="rfq.quoteStatus === 'Draft'" class="rfq-status draft">{{ getStatusLabel(rfq.quoteStatus) }}</span>
            <span *ngIf="rfq.quoteStatus === 'Open'" class="rfq-status open">{{ getStatusLabel(rfq.quoteStatus) }}</span>
          </div>
            <h4 class="rfq-name">{{ rfq.rfqName }}</h4>
            <div class="rfq-number">{{ rfq.rfqSequenceId }}</div>
        </div>
        <div class="col-sm-8" *ngIf="rfq.source !== 'SUW'">
          <span class="rfq-date">This private opportunity was created by you</span>
        </div>
        <ng-container *ngIf="rfq.source === 'SUW'">        
        <div class="col-md-5">
          <span class="rfq-date"><span>Quote by:</span> {{ rfq.quoteBy ? (rfq.quoteBy | date: 'MM/dd/yyyy') : '--' }}</span>
           <span class="rfq-date">
            <span>Certifications:</span>
            <span class="tooltip-container">
              <span class="text-truncate" appTooltipOnEllipsis>{{formatCertificateList(rfq)}}</span>
              <span class="tooltip-popup">{{formatCertificateList(rfq)}}</span>
            </span>
          </span>
          <span class="rfq-date">
            <span>Inspections:</span>
            <span class="tooltip-container">
              <span class="text-truncate" appTooltipOnEllipsis>{{rfq.inspection?.length ? rfq.inspection?.join(', ') : '-'}}</span>
              <span class="tooltip-popup">{{rfq.inspection?.length ? rfq.inspection?.join(', ') : '-'}}</span>
            </span>
          </span>
        </div>
        <div class="col">
          <span class="rfq-date"><span>Deliver by:</span> {{ rfq.deliverBy ? (rfq.deliverBy | date: 'MM/dd/yyyy') : '--' }}</span>
           <span class="rfq-date">
            <span>Industry:</span>
            <span class="tooltip-container">
             <span class="text-truncate" appTooltipOnEllipsis> {{rfq.industry?rfq.industry:'-'}}</span>
              <span class="tooltip-popup">
               {{rfq.industry}}
              </span>
            </span>
          </span>
          <span class="rfq-date"><span>Payment Terms:</span> {{rfq.paymentTerms?rfq.paymentTerms:'-'}}</span>
        </div>
      </ng-container>
      </div>
      <div class="bottom-container">
        <div class="rfq-actions">
          <button class="light-btn" [disabled]="rfq.quoteStatus == 'Submit'" (click)="onSendQuoteClick(rfq)">Quote</button>
          <button class="download-btn" [disabled]="rfq.quoteStatus !== 'Submit'"(click)="sendViaEmail(rfq)" *ngIf="rfq.version===2">Send Via Email</button>
          <button class="download-btn" *ngIf="rfq.source == 'SUW'"
           (click)="openRfqDetailsDrawer(rfq)">View Details</button>
          <button class="download-btn" [disabled]="rfq.quoteStatus !== 'Submit'" (click)="downloadPdfFile(rfq)">Download Quote</button>
        </div>
        <div class="rfq-body">
          <div class="rfq-company">{{ rfq.buyerCompanyName }}</div>
          <div class="rfq-email">{{ rfq.buyerEmailAddress }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!isData" class="no-data-message">No RFQs Found</div>
  </div>
  <pagination-controls  *ngIf="isData" (pageChange)="currentPage = $event"></pagination-controls>
</div>
<div class="full-page-overlay" *ngIf="showLoader || showLoaderwhilesendemailOrDownload">
  <div class="rfqLoader"></div>
</div>